import { Helmet } from 'react-helmet';

interface SEOProps {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
}

export default function SEO({
    title = "Dulain | Creative Developer & Visual Storyteller",
    description = "Dulain - Polymath, creative developer, and visual storyteller. I design visuals, edit stories, and use code to bring ideas to life.",
    image = "https://realdulain.com/og-image.jpg",
    url = "https://realdulain.com"
}: SEOProps) {
    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content="Dulain, Dulain Gunawardhana, realdulain, creative developer, polymath, portfolio, web developer, visual storyteller" />
            <meta name="author" content="Dulain" />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:creator" content="@notdulain" />

            {/* Canonical URL */}
            <link rel="canonical" href={url} />

            {/* Structured Data (JSON-LD) */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Person",
                    "name": "Dulain",
                    "url": "https://realdulain.com",
                    "image": "https://realdulain.com/og-image.jpg",
                    "sameAs": [
                        "https://github.com/notdulain",
                        "https://x.com/probablydulain",
                        "https://www.linkedin.com/in/dulain-nethwin-gunawardhana-41b251294/"
                    ],
                    "jobTitle": "Software Engineer",
                    "description": "Polymath, creative developer, and visual storyteller",
                    "email": "mailto:03dulain@gmail.com",
                    "knowsAbout": [
                        "Web Development",
                        "Creative Coding",
                        "Visual Design",
                        "Video Editing",
                        "Software Engineering"
                    ]
                })}
            </script>

            {/* NEW: WebSite Schema - This controls the site name in Google */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    "name": "Dulain's Portfolio",  // This is what Google will show
                    "alternateName": "Dulain's Portfolio",
                    "url": "https://realdulain.com"
                })}
            </script>
        </Helmet>
    );
}